// extracted by mini-css-extract-plugin
export default {"component":"HealthBar_component__ZLgib","bar":"HealthBar_bar__CbSOa","flashing":"HealthBar_flashing__zu8qb","flash":"HealthBar_flash__RKLzi"};